export default function IconToggle({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <path d="M12.0001 8C11.7349 8 11.4806 8.10543 11.293 8.29297L6.29304 13.293C5.90252 13.6835 5.90252 14.3165 6.29304 14.707C6.68357 15.0976 7.31658 15.0976 7.70711 14.707L12.0001 10.4141L16.293 14.707C16.6836 15.0976 17.3166 15.0976 17.7071 14.707C18.0976 14.3165 18.0976 13.6835 17.7071 13.293L12.7071 8.29297C12.5196 8.10543 12.2653 8 12.0001 8Z"></path>
        </svg>
    );
}
